const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/workItem.ts';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

export const REQUEST_ACTION_TYPES_LOAD_REGISTER_WORK_ITEM = kisapiActionTypes('PATAPP_LOAD_WORKITEM_RECORD');

/**
 * Loads the WorkItem with the given WORKID.
 */
export function loadPatAppRegisterWorkItem(workId: string) {
    const endpoint = `workitems/register/${workId}`;
    return createPatapiCall(REQUEST_ACTION_TYPES_LOAD_REGISTER_WORK_ITEM, endpoint, HttpMethod.GET, { workId });
}
